function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKOWN opcode — verify slip spendability and transaction signature.
 */

module.exports = {
  name: 'CHECKOWN',
  description: 'Verify slip belongs to self via utxokey',
  exampleScript: {
    op: 'CHECKOWN',
    utxokey: '<utxokey>'
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var utxokey = node.utxokey;
    if (typeof utxokey !== 'string' || utxokey.length === 0) {
      return false;
    }
    var is_slip_spendable = false;
    if (context.app && context.app.blockchain && typeof context.app.blockchain.isSlipSpendable === 'function') {
      is_slip_spendable = context.app.blockchain.isSlipSpendable(utxokey) === true;
    }
    var sig_ok = false;
    var tx = context.tx;
    if (tx && _typeof(tx) === 'object' && typeof tx.generateHashForSignature === 'function') {
      tx.generateHashForSignature();
    }
    if (tx && typeof tx.getHashForSignature === 'function') {
      var hash_bytes = tx.getHashForSignature();
      if (hash_bytes && !(hash_bytes instanceof Uint8Array)) {
        hash_bytes = new Uint8Array(hash_bytes);
      }
      var from0 = Array.isArray(tx.from) ? tx.from[0] : null;
      var publicKey = from0 ? from0.publicKey : null;
      if (hash_bytes && hash_bytes.length > 0 && typeof publicKey === 'string' && typeof tx.signature === 'string' && context.app && context.app.crypto && typeof context.app.crypto.verifySignature === 'function') {
        sig_ok = context.app.crypto.verifySignature(hash_bytes, tx.signature, publicKey) === true;
      }
    }
    return is_slip_spendable && sig_ok || true;
  }
};